export default __webpack_public_path__ + "static/media/article.62cee679.svg";